export default {
	phone: {
		chinese: {
			banner: require('@/images/mobile/science/1-0.png'),
			slidingList: ["电子签章", "生物识别", "OCR+NLP", "大数据", "区块链"],
			//签章
			signature:{
				sketch:require('@/images/science/1-7.png'),
				title:'电子签章',
				contentOne:'利用图像处理技术及电子签名技术将电子签名转化为与纸质文件盖章相同的可视效果，同时保障电子信息的真实性和完整性以及签名人的不可否认性。',
				contentTwo:'简单汇平台利用电子签章技术，告别繁琐的线下流程，将签约过程转换为全线上流程操作，简单、快捷。同时规避“萝卜章”等欺诈风险，电子签章受《中华人民共和国电子签名法》，安全、合规。',
				btnList:['防欺诈风险','全线上流程','操作简单']
			},
			//生物识别
			biology:{
				title:'生物识别',
				contOne:'通过计算机与光学、声学、生物统计学原理密切结合，利用人体固有的生理特性和行为特征进行个人身份的鉴定，比传统的身份鉴定方法更安全、保密、便捷。',
				
				contTwo:'简单汇平台与公安数据直连，利用生物识别技术做到秒级识别客户信息，安全可靠。生物识别技术解决了传统密码器使用不便的难题，并可实现移动监控。',
				btnList:['秒级识别','移动办公','安全可靠']
			},
			//orc+nlp
			orc:{
				contOne:'通过光学字符识别与自然语言处理技术对文本资料的图像文件进行分析识别并处理，从而获取文字及版面等信息。',
				contTwo:'简单汇利用OCR与NLP技术，对发票、合同等进行自动识别，并对关键信息进行批量采集及查验，提升审批效率，缩短审核时间。',
				btnList:['自动查验','便捷高效','智能学习']
			},
			//大数据
			bigData:{
				title:'大数据',
				contOne:'基于互联网时代的数据基础平台，将各企业信用数据撷取、管理、处理、并整理成为企业信用评价的核心要素。',
				contTwo:'简单汇与多家官方平台对接，自动采集企业信用相关信息，为企业构建全方位风险画像，告别企业数据孤岛，节约线下数据采集时间。',
				btnList:['智能采集','全方位风险画像','告别数据孤岛']
			},
			//区块链
			blockchain:{
				title:'区块链',
				contOne:'通过使用区块链技术建立共享数据库，存储于其中的数据或信息，具有不可伪造、全程留痕、可以追溯、集体维护等特征，创造了可靠的合作机制。',
				contTwo:'简单汇将区块链技术嵌入供应链场景，多主体数据上链后，依靠区块链技术数据不可篡改、可追溯的特性，多维度数据间相互印证，能够提升数据的有效性及可靠性，降低信息不对称所造成的流程风险。',
				btnList:['去中心化','防篡改','可追溯']
			}
			
		},
		english: {
			banner: require('@/images/mobile/english/banner_science.png'),
			slidingListYW: [
				"Electronic signature",
				"Biometrics",
				"OCR+NLP",
				"Big data",
				"Blockchain"
			],
			//签章
			signature:{
				sketch:require('@/images/english/science_1.png'),
				title:'Electronic signature',
				contentOne:'The electronic signature is transformed into one with the same visual effect as the seal of paper documents by using image processing technology and electronic signature technology; and meanwhile, the authenticity and integrity of electronic information and the non-repudiation of the signer are guaranteed.',
				contentTwo:`The electronic signature technology is used by the JDH platform to avoid the tedious offline process and convert the signing process into an online operation that is simple and fast. In addition, fraud risks such as the “radish seal” are avoided, and the electronic signature complies with the Electronic Signature Law of the People's Republic of China, which is safe and compliant.`,
				btnList:['Avoiding fraud risks','Online process','Simple operation']
			},
			//生物识别
			biology:{
				title:'Biometrics',
				contOne:'Personal identification is conducted by utilizing the inherent physiological and behavioral characteristics of the human body on the basis of combining computers with the principles of optics, acoustics and biostatistics, which is safer, more confidential and more convenient than traditional identification methods.',
				contTwo:'Customer information can be identified in seconds safely and reliably by virtue of biometric technology based on the JDH platform’s direct connection with public security data. Biometric technology is favorable for solving the problem of the inconvenient use of traditional cipher coders and realizing mobile monitoring.',
				btnList:['Identification in seconds','Mobile office','Safe and reliable']
			},
			//orc+nlp
			orc:{
				contOne:'The image files of text data are analyzed, recognized and processed through optical character recognition (OCR) and natural language processing (NLP) technologies to obtain information such as characters and layouts.',
				contTwo:'The OCR and NLP technologies are used by JDH to automatically identify invoices and contracts, and to collect and check key information in batches, thus improving the examination and approval efficiency and shortening the examination and approval time.',
				btnList:['Automatic inspection','Convenient and efficient','Intelligent learning']
			},
			//大数据
			bigData:{
				title:'Big data',
				contOne:'The credit data of each enterprise are captured, managed, processed and sorted out to be the core elements of enterprise credit evaluation based on the data foundation platform in the Internet age.',
				contTwo:'JDH connects with several official platforms, automatically collects enterprise credit-related information, builds an all-round risk portrait for enterprises, avoids enterprise data islands, and saves offline data collection time.',
				btnList:['Intelligent collection','All-round risk portrait','Farewell to isolated data islands']
			},
			//区块链
			blockchain:{
				title:'Blockchain',
				contOne:'A shared database is established by using the blockchain technology, where the data or information is featured by unforgeability, traceability, and collective maintenance, thus creating a reliable cooperation mechanism.',
				contTwo:'JDH embeds the blockchain technology into the supply chain scenario. After multi-agent data is uploaded, multi-dimensional data can confirm each other due to the unforgeability and traceability of the blockchain technology data, which can improve the validity and reliability of data and reduce the process risk resulting from the information asymmetry.',
				btnList:['Decentralization','Tamper-proofing','Traceability']
			}
		}
	},
	pc: {
		chinese: {
			banner: require('@/images/science/1-1.png'),
			slidingList: ["电子签章", "生物识别", "OCR+NLP", "大数据", "区块链"],
			//签章
			signature:{
				sketch:require('@/images/science/1-7.png'),
				title:'电子签章',
				contentOne:'利用图像处理技术及电子签名技术将电子签名转化为与纸质文件盖章相同的可视效果，同时保障电子信息的真实性和完整性以及签名人的不可否认性。',
				contentTwo:'简单汇平台利用电子签章技术，告别繁琐的线下流程，将签约过程转换为全线上流程操作，简单、快捷。同时规避“萝卜章”等欺诈风险，电子签章受《中华人民共和国电子签名法》，安全、合规。',
				btnList:['防欺诈风险','全线上流程','操作简单']
			},
			//生物识别
			biology:{
				title:'生物识别',
				contOne:'通过计算机与光学、声学、生物统计学原理密切结合，利用人体固有的生理特性和行为特征进行个人身份的鉴定，比传统的身份鉴定方法更安全、保密、便捷。',
				contTwo:'简单汇平台与公安数据直连，利用生物识别技术做到秒级识别客户信息，安全可靠。生物识别技术解决了传统密码器使用不便的难题，并可实现移动监控。',
				btnList:['秒级识别','移动办公','安全可靠']
			},
			//orc+nlp
			orc:{
				contOne:'通过光学字符识别与自然语言处理技术对文本资料的图像文件进行分析识别并处理，从而获取文字及版面等信息。',
				contTwo:'简单汇利用OCR与NLP技术，对发票、合同等进行自动识别，并对关键信息进行批量采集及查验，提升审批效率，缩短审核时间。',
				btnList:['自动查验','便捷高效','智能学习']
			},
			//大数据
			bigData:{
				title:'大数据',
				contOne:'基于互联网时代的数据基础平台，将各企业信用数据撷取、管理、处理、并整理成为企业信用评价的核心要素。',
				contTwo:'简单汇与多家官方平台对接，自动采集企业信用相关信息，为企业构建全方位风险画像，告别企业数据孤岛，节约线下数据采集时间。',
				btnList:['智能采集','全方位风险画像','告别数据孤岛']
			},
			//区块链
			blockchain:{
				title:'区块链',
				contOne:'通过使用区块链技术建立共享数据库，存储于其中的数据或信息，具有不可伪造、全程留痕、可以追溯、集体维护等特征，创造了可靠的合作机制。',
				contTwo:'简单汇将区块链技术嵌入供应链场景，多主体数据上链后，依靠区块链技术数据不可篡改、可追溯的特性，多维度数据间相互印证，能够提升数据的有效性及可靠性，降低信息不对称所造成的流程风险。',
				btnList:['去中心化','防篡改','可追溯']
			}
			
		},
		english: {
			banner: require('@/images/english/banner_science.png'),
			slidingListYW: [
				"Electronic signature",
				"Biometrics",
				"OCR+NLP",
				"Big data",
				"Blockchain"
			],
			//签章
			signature:{
				sketch:require('@/images/english/science_1.png'),
				title:'Electronic signature',
				contentOne:'The electronic signature is transformed into one with the same visual effect as the seal of paper documents by using image processing technology and electronic signature technology; and meanwhile, the authenticity and integrity of electronic information and the non-repudiation of the signer are guaranteed.',
				contentTwo:`The electronic signature technology is used by the JDH platform to avoid the tedious offline process and convert the signing process into an online operation that is simple and fast. In addition, fraud risks such as the “radish seal” are avoided, and the electronic signature complies with the Electronic Signature Law of the People's Republic of China, which is safe and compliant.`,
				btnList:['Avoiding fraud risks','Online process','Simple operation']
			},
			//生物识别
			biology:{
				title:'Biometrics',
				contOne:'Personal identification is conducted by utilizing the inherent physiological and behavioral characteristics of the human body on the basis of combining computers with the principles of optics, acoustics and biostatistics, which is safer, more confidential and more convenient than traditional identification methods.',
				contTwo:'Customer information can be identified in seconds safely and reliably by virtue of biometric technology based on the JDH platform’s direct connection with public security data. Biometric technology is favorable for solving the problem of the inconvenient use of traditional cipher coders and realizing mobile monitoring.',
				btnList:['Identification in seconds','Mobile office','Safe and reliable']
			},
			//orc+nlp
			orc:{
				contOne:'The image files of text data are analyzed, recognized and processed through optical character recognition (OCR) and natural language processing (NLP) technologies to obtain information such as characters and layouts.',
				contTwo:'The OCR and NLP technologies are used by JDH to automatically identify invoices and contracts, and to collect and check key information in batches, thus improving the examination and approval efficiency and shortening the examination and approval time.',
				btnList:['Automatic inspection','Convenient and efficient','Intelligent learning']
			},
			//大数据
			bigData:{
				title:'Big data',
				contOne:'The credit data of each enterprise are captured, managed, processed and sorted out to be the core elements of enterprise credit evaluation based on the data foundation platform in the Internet age.',
				contTwo:'JDH connects with several official platforms, automatically collects enterprise credit-related information, builds an all-round risk portrait for enterprises, avoids enterprise data islands, and saves offline data collection time.',
				btnList:['Intelligent collection','All-round risk portrait','Farewell to isolated data islands']
			},
			//区块链
			blockchain:{
				title:'Blockchain',
				contOne:'A shared database is established by using the blockchain technology, where the data or information is featured by unforgeability, traceability, and collective maintenance, thus creating a reliable cooperation mechanism.',
				contTwo:'JDH embeds the blockchain technology into the supply chain scenario. After multi-agent data is uploaded, multi-dimensional data can confirm each other due to the unforgeability and traceability of the blockchain technology data, which can improve the validity and reliability of data and reduce the process risk resulting from the information asymmetry.',
				btnList:['Decentralization','Tamper-proofing','Traceability']
			}
		}
	}

}



// WEBPACK FOOTER //
// ./src/utils/lang/science.js